import * as React from 'react';
import { Button } from '@blueprintjs/core';
import { t } from '@patterns/locale';
export function SaveButton(_a) {
    var className = _a.className, fill = _a.fill, intent = _a.intent, disabled = _a.disabled, minimal = _a.minimal, onClick = _a.onClick, style = _a.style, text = _a.text;
    return (React.createElement(Button, { className: className, minimal: minimal, disabled: disabled, style: style, fill: fill, icon: "cloud-upload", intent: intent || (disabled ? 'none' : 'success'), text: text || t('save'), onClick: onClick }));
}
//# sourceMappingURL=save_button.js.map